import { render, staticRenderFns } from "./VendorAccounts.vue?vue&type=template&id=3bcb4c26&scoped=true&"
import script from "./VendorAccounts.vue?vue&type=script&lang=js&"
export * from "./VendorAccounts.vue?vue&type=script&lang=js&"
import style0 from "./VendorAccounts.vue?vue&type=style&index=0&id=3bcb4c26&lang=scss&scoped=true&"
import style1 from "./VendorAccounts.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcb4c26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bcb4c26')) {
      api.createRecord('3bcb4c26', component.options)
    } else {
      api.reload('3bcb4c26', component.options)
    }
    module.hot.accept("./VendorAccounts.vue?vue&type=template&id=3bcb4c26&scoped=true&", function () {
      api.rerender('3bcb4c26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/settings/vendors/VendorAccounts.vue"
export default component.exports